import React, { useState, useEffect } from 'react'
import { AccountCircleIcon } from '../components'
import { ApplicationState } from '../store'
import { useSelector } from 'react-redux'
import { ProfileState } from '../store/profile'
import { APIRequest } from '../api'
import { Logger } from '../modules'

export const useProfileIcon = ({ profile }: { profile?: ProfileState } = {}): { icon: React.ReactElement } => {
	const { profile: currentUserProfile, config } = useSelector((state: ApplicationState) => state)
	const [avatarBlobUrl, setAvatarBlobUrl] = useState<string | null>(null)

	const selectedProfile = profile || currentUserProfile

	useEffect(() => {
		const fetchAvatar = async (): Promise<void> => {
			if (selectedProfile.avatarBlobUrl && !avatarBlobUrl) {
				const accessToken = APIRequest.getAccessToken()

				try {
					const res = await fetch(selectedProfile.avatarBlobUrl, {
						headers: {
							Authorization: `Bearer ${accessToken}`
						}
					})
					const blob = await res.blob()
					const bloburl = URL.createObjectURL(blob)
					setAvatarBlobUrl(bloburl)
				} catch (e) {
					Logger.error(`Failed to fetch avatar: ${ e}`)
					// If fetch fails, fall back to default icon
					setAvatarBlobUrl(null)
				}
			}
		}

		fetchAvatar()
	}, [selectedProfile.avatarBlobUrl, config, avatarBlobUrl])

	return avatarBlobUrl ? { icon: <img src={avatarBlobUrl} alt="avatar" /> } : { icon: <AccountCircleIcon /> }
}
